import { Link } from 'react-router-dom';

type BrandProps = { compact?: boolean } & (
  | { interactive: true; doorOpen: boolean; onDoorClick: () => void; onDoorOpened: () => void }
  | { interactive?: false }
);

export function Brand(props: BrandProps) {
  const interactive = props.interactive === true;
  const mark = <svg className="brand-mark" viewBox="0 0 100 110" aria-hidden="true">
    <path className="brand-door-light" fill="#50adf5" d="M34 12h28v65l32 23H52L34 76Z" />
    <g className="brand-door-leaf" onTransitionEnd={(event) => {
      if (props.interactive && event.target === event.currentTarget && (event.propertyName === 'transform' || event.propertyName === '-webkit-transform')) props.onDoorOpened();
    }}>
      <path fill="currentColor" d={interactive ? 'M34 12h28v65H34Z' : 'M8 20 48 6v80L8 72Z'} />
      <circle cx={interactive ? 54 : 40} cy="47" r="3" fill="#50adf5" />
    </g>
  </svg>;
  return (
    <span className={`brand${props.compact ? ' brand--compact' : ''}`}>
      {props.interactive ? <button className="brand-door-button" type="button" aria-label="Изнанка — записаться на экскурсию" aria-haspopup="dialog" aria-expanded={props.doorOpen} onClick={props.onDoorClick}>
        {mark}<span className="brand-booking-hint">Нажми на дверь</span>
      </button> : mark}
      {props.interactive ? <Link className="brand-word" to="/" aria-label="Изнанка — главная">IZNANKA</Link> : <span className="brand-word" aria-label="Изнанка">IZNANKA</span>}
    </span>
  );
}
